const getBool = val => !!JSON.parse(String(val).toLowerCase())

module.exports = getBool
